import React from "react";
export default function ViewAvatar() {
  return <div style={{ marginTop: "3rem" }}>ViewAvatar</div>;
}
